<div class="position-relative overflow-hidden">
    <div>
        <div #swiper class="swiper" [class.is-client]="isClient">
            <div class="swiper-wrapper">
                @for (banner of banners; track banner) {
                    <div class="swiper-slide">
                        <app-slide [banner]="banner" [fullwidth]="fullwidth" />
                    </div>
                }
            </div>
        </div>

        <div class="swiper-controls">
            <div class="container-xxl gx-9 gx-md-8 gx-lg-10 gx-xxl-0 mb-5 mb-xl-12">
                <div class="d-flex align-items-center justify-content-center justify-content-md-start">
                    <div class="gx-9 gx-md-8 gx-lg-12 gx-xxl-0 mb-md-11 mb-12"></div>
                    <div class="navigation-box d-flex border border-gray-100 me-0 me-md-6 d-none d-md-flex">
                        <div #swiperNavigationPrev class="swiper-btn prev"></div>
                        <div #swiperNavigationNext class="swiper-btn next"></div>
                    </div>
                    <div #swiperPagination class="pagination banner-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</div>
